import { useAuth } from 'context/useAuth';
import { useEffect, useState } from 'react';
import { useAppSettings } from 'context/appsettingsContext';

export default function useAxiosGet(endpoint: string, endpointData: any = {}) {
  
  const settings = useAppSettings();
  const { authorisedUser } = useAuth();
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function getData() {
      setLoading(true);
        try {
          
          let items: any[] = [];

          switch (endpoint) {
            
            case 'Roles':
              items = [
                { id: 'Technical-Agent', name: 'Technical-Agent' },
                { id: 'Installer', name: 'Installer' },
                //{ id: 'Company-Admin', name: 'Company-Admin' },
                { id: 'Admin', name: 'Admin' },
              ];
              break;
            
            case 'SUBSCRIPTION_PLANS':
              items = [];
              break;

            default:
              const message = `Endpoint not handled : ${endpoint}`;
              console.error(message);
              alert(message);
          }

          if (cancelled) return;
          setData(items as any);

        } catch (error: any) {
          if (cancelled) return;
          //if (axios.isAxiosError(error)) {
            setError(error.message);
          //}
        } finally {
          if (!cancelled) setLoading(false);
        }
    }
    getData();
    return () => { cancelled = true; };
  }, [authorisedUser.accessToken, endpoint, settings?.baseURL]);

  return {
    data,
    loading,
    error,
  };
}
